var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { message } from 'antd';
var messageStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
};
export var setMessage = function (props) {
    var _a = __assign({}, props), text = _a.text, status = _a.status, _b = _a.duration, duration = _b === void 0 ? 1.5 : _b, _c = _a.maxCount, maxCount = _c === void 0 ? 3 : _c, key = _a.key;
    switch (status) {
        case 'success':
            void message.success({
                key: key,
                content: text,
                style: messageStyle,
                duration: duration,
                // @ts-ignore
                maxCount: maxCount
            });
            break;
        case 'error':
            void message.error({
                key: key,
                content: text,
                style: messageStyle,
                duration: duration,
                // @ts-ignore
                maxCount: maxCount,
            });
            break;
        case 'warning':
            void message.warning({
                key: key,
                content: text,
                style: messageStyle,
                duration: duration,
                // @ts-ignore
                maxCount: maxCount,
            });
            break;
        case 'loading':
            void message.loading({
                key: key,
                content: text,
                style: messageStyle,
                duration: duration,
                // @ts-ignore
                maxCount: maxCount,
            });
            break;
        default:
        case 'info':
            void message.info({
                key: key,
                content: text,
                style: messageStyle,
                duration: duration,
                // @ts-ignore
                maxCount: maxCount,
            });
            break;
    }
};
export var destroyMessage = function (key) {
    void message.destroy(key);
};
